module.exports = __webpack_public_path__ + "static/media/zolePlayed_500_1000.64fd9202.png";